import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import store from '@/store';
import clerk from '@/lib/clerk';
import {
  dispatchGetEnforce2Fa,
  dispatchUpdateEnforce2Fa,
} from '@/store/main/actionsMain';
import { readAssertedCompanyId } from '@/store/main/getters';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import { usePermissionComposable } from '@/composables/usePermission';
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';
import Enforce2FaConfirmDialog from '@/views/pages/enforce2Fa/Enforce2FaConfirmDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Enforce2FaPage',
  setup(__props) {

const m = defineMessages({
  title: '二要素認証の利用',
  description:
    '全ユーザーに対して、ログイン時に二要素認証の利用を義務づけることができます。',
  enforce: '必須化する',
  noOptionNotice:
    '「二要素認証オプション」を追加購入いただいたお客様がご利用になれる機能です。お求めの場合は、ケミカンメニューバー右上の「お問い合わせ」からお問い合わせください。',
  samlNotice: 'SAML認証が有効なため、二要素認証を必須化することはできません。',
  currentUserNo2FaNotice:
    '必須化するには、まずご自身のマイページで二要素認証を設定してください。',
});

const { isFeatureActive, COMPANY_FEATURES } = useCompanyFeatureComposable();
const { hasPermission, PERMISSIONS: P } = usePermissionComposable();

const isOptionActive = computed(() =>
  isFeatureActive(COMPANY_FEATURES.ENFORCE_2FA)
);
const isSamlLoginEnabled = computed(() =>
  isFeatureActive(COMPANY_FEATURES.MANAGE_SAML_AUTHENTICATION)
);
const hasEditPermission = computed(() =>
  hasPermission(P.ENFORCE_2FA_AUTHENTICATION)
);
// 管理者自身が未設定のまま適用すると、自分がログアウトされてしまうため設定済みを必須とする。
const currentUserHas2Fa = computed(() => {
  const user = clerk.user;
  return (
    !!user?.totpEnabled ||
    !!user?.phoneNumbers?.some(
      (ph) =>
        ph.verification?.status === 'verified' && ph.reservedForSecondFactor
    )
  );
});
const isLoading = ref(true);
const isSaving = ref(false);
const isConfirmDialogOpen = ref(false);
const enabled = ref(false);
const savedEnabled = ref(false);
// SAMLや管理者自身の2FA未設定は「必須化をONにする」操作だけを止める。
// すでにONの場合は、状況が変わってもOFFに戻せるようにする。
const canEdit = computed(
  () =>
    isOptionActive.value &&
    hasEditPermission.value &&
    (savedEnabled.value ||
      (!isSamlLoginEnabled.value && currentUserHas2Fa.value))
);

onMounted(async () => {
  try {
    if (isOptionActive.value && hasEditPermission.value) {
      const response = await dispatchGetEnforce2Fa(store, {
        companyId: readAssertedCompanyId(store),
      });
      enabled.value = response.data.enabled;
      savedEnabled.value = response.data.enabled;
    }
  } finally {
    isLoading.value = false;
  }
});

const submit = () => {
  if (!canEdit.value) {
    return;
  }
  // OFF→ONのときだけ、全ユーザーへの影響を確認するダイアログを出す。
  if (enabled.value && !savedEnabled.value) {
    isConfirmDialogOpen.value = true;
    return;
  }
  save();
};

const save = async () => {
  isSaving.value = true;
  try {
    await dispatchUpdateEnforce2Fa(store, {
      companyId: readAssertedCompanyId(store),
      enabled: enabled.value,
    });
    savedEnabled.value = enabled.value;
  } catch (error) {
    enabled.value = savedEnabled.value;
  } finally {
    isSaving.value = false;
    isConfirmDialogOpen.value = false;
  }
};

return { __sfc: true,m, isFeatureActive, COMPANY_FEATURES, hasPermission, P, isOptionActive, isSamlLoginEnabled, hasEditPermission, currentUserHas2Fa, isLoading, isSaving, isConfirmDialogOpen, enabled, savedEnabled, canEdit, submit, save, sharedMessages, Enforce2FaConfirmDialog }
}

})